import { Design } from '@/types';

export const setLookupIdAsId = (design: Design) => {
  if (design.customerUpload && design.lookupId) {
    design.id = design.lookupId;
  }

  return design;
};
